// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__ovcaC","info":"PatientInfo_info__EZJN7"};